import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import _ from "lodash";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "src/redux";
import api from "../../util/api";
import { validate } from "../../util/types";
import { handleErrorEvents } from "../errorHandler/actions";
import { tReduxAction } from "../types";
import { tAdminUserState } from "./types";

export const adminUpdateUserEmail = (myEmail: string, AdminUserParams: tAdminUserState): tReduxAction => {
  return async (dispatch) => {
    try {
      const aUser = _.cloneDeep(AdminUserParams);
      aUser.email = myEmail;
      await api.post({ endpoint: "/admin/userUpdate", body: aUser });
      dispatch({
        type: "RIBBON",
        message: "Email changed",
      });
    } catch (error) {
      dispatch(handleErrorEvents("Could not update email", "error", new Error("Could not update email")));
    }
  };
};

export const fetchAdminUserData = (myCompanySnapshot: firebase.firestore.QuerySnapshot): tReduxAction => {
  return (dispatch) => {
    try {
      if (myCompanySnapshot.empty) {
        console.warn("Couldn't find the user!");
        return undefined;
      }
      const aUser = validate("tUser")(myCompanySnapshot.docs[0].data());
      dispatch({
        type: "ADMIN_SET_USER",
        user: aUser,
      });
    } catch (error) {
      console.warn(error);
    }
    return undefined;
  };
};

export const useFetchAdminUserSettings = (id?: string, type?: "brands" | "reps" | "boutiques"): void => {
  const dispatch = useAppDispatch();
  const aCompanyRefPath = useSelector(({ UserReducer }) => UserReducer.profile.companyRefPath);
  const aAdminCompanyPath = id && type ? `${type}/${id}` : undefined;
  const aAccountType = useSelector(({ UserReducer }) => UserReducer.profile.accountType);
  useEffect(() => {
    if (!aCompanyRefPath && aAccountType !== "tmtAdmin") {
      dispatch({ type: "ADMIN_RESET_SETTINGS" });
      return undefined;
    }

    return firebase
      .firestore()
      .collection("users")
      .where("companyRefPath", "==", `${type}/${id}`)
      .onSnapshot((myCompanySnapshot) => {
        if (aAccountType === "tmtAdmin") {
          dispatch(fetchAdminUserData(myCompanySnapshot));
        }
      });
  }, [aCompanyRefPath, aAccountType, dispatch, aAdminCompanyPath, id, type]);
};
